/**
 * Format utilities for numbers, currency, and other display values
 */

/**
 * Format a number with Vietnamese locale abbreviations
 * @param value - Number or string to format
 * @returns Formatted string with k/tr/tỷ suffixes or "_ _" for invalid values
 * 
 * @example
 * formatNumber(1500) // "1k"
 * formatNumber(1500000) // "1tr"
 * formatNumber(1500000000) // "1.5tỷ"
 */
export function formatNumber(value?: number | string): string {
  if (value === undefined || value === null) return "_ _"
  const num = typeof value === "string" ? parseFloat(value) : value
  if (isNaN(num)) return "_ _"

  if (num >= 1000000000) {
    return `${(num / 1000000000).toFixed(1)}tỷ`
  }
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(0)}tr`
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(0)}k`
  }
  return num.toLocaleString()
}

/**
 * Format a phone number with Vietnamese country code
 * @param phoneNumber - Phone number to format
 * @returns Formatted phone number with (+84) prefix
 * 
 * @example
 * formatPhoneNumber("0912345678") // "(+84) 912345678"
 */
export function formatPhoneNumber(phoneNumber?: string): string {
  if (!phoneNumber) return ""
  return `(+84) ${phoneNumber.replace(/^0/, "")}`
}
